import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import { ReviewDocument } from "../types";

export interface UploadedDocumentsSectionProps {
  documents: ReviewDocument[];
}

export const UploadedDocumentsSection: React.FC<UploadedDocumentsSectionProps> = ({ documents }) => {
  const hasDocuments = documents.length > 0;
  const allUploaded = hasDocuments && documents.every((doc) => doc.documentId !== null);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          Uploaded Documents
        </Typography>

        {!hasDocuments ? (
          <Box
            sx={{
              p: 2,
              bgcolor: "grey.50",
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No documents required for this permit type
            </Typography>
          </Box>
        ) : (
          <>
            {allUploaded && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <CheckCircleIcon color="success" fontSize="small" />
                <Typography variant="body2" color="success.main">
                  All required documents uploaded
                </Typography>
              </Box>
            )}
            <List dense disablePadding>
              {documents.map((doc) => (
                <ListItem key={doc.documentTypeId} disableGutters>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <DescriptionIcon color={doc.documentId ? "success" : "action"} />
                  </ListItemIcon>
                  <ListItemText
                    primary={doc.documentTypeName}
                    secondary={doc.documentId ? "Uploaded" : "Pending upload"}
                    secondaryTypographyProps={{
                      color: doc.documentId ? "success.main" : "warning.main",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default UploadedDocumentsSection;
